export default "__VITE_ASSET__B8l6xTKb__"